@if (structuresWidget) {
    <mvs-widget
            [widgetData]="structuresWidget"
            (onObjectSelect)="onStructureSelect($event)"
    ></mvs-widget>
}
